var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBussinesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.10931H4V6.10931H20V4.10931ZM21 14.1093V12.1093L20 7.10931H4L3 12.1093V14.1093H4V20.1093H14V14.1093H18V20.1093H20V14.1093H21ZM12 18.1093H6V14.1093H12V18.1093Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.10931H4V6.10931H20V4.10931ZM21 14.1093V12.1093L20 7.10931H4L3 12.1093V14.1093H4V20.1093H14V14.1093H18V20.1093H20V14.1093H21ZM12 18.1093H6V14.1093H12V18.1093Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussinesInactive);
export default __webpack_public_path__ + "static/media/BussinesInactive.9c2d35efa7e26774b30293717ff44d69.svg";
export { ForwardRef as ReactComponent };